import { createApp, h, reactive } from 'vue';
import router from './router';
import PrimeVue from 'primevue/config';
import AutoComplete from 'primevue/autocomplete';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Avatar from 'primevue/avatar';
import AvatarGroup from 'primevue/avatargroup';
import Badge from 'primevue/badge';
import BadgeDirective from "primevue/badgedirective";
import Button from 'primevue/button';
import Breadcrumb from 'primevue/breadcrumb';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import CascadeSelect from 'primevue/cascadeselect';
import Carousel from 'primevue/carousel';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Chip from 'primevue/chip';
import Chips from 'primevue/chips';
import ColorPicker from 'primevue/colorpicker';
import Column from 'primevue/column';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmationService from 'primevue/confirmationservice';
import ContextMenu from 'primevue/contextmenu';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
import Dropdown from 'primevue/dropdown';
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import FullCalendar from 'primevue/fullcalendar';
import Galleria from 'primevue/galleria';
import Image from 'primevue/image';
import InlineMessage from 'primevue/inlinemessage';
import Inplace from 'primevue/inplace';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import Knob from 'primevue/knob';
import Listbox from 'primevue/listbox';
import MegaMenu from 'primevue/megamenu';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import OrderList from 'primevue/orderlist';
import OrganizationChart from 'primevue/organizationchart';
import OverlayPanel from 'primevue/overlaypanel';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
import PickList from 'primevue/picklist';
import ProgressBar from 'primevue/progressbar';
import Rating from 'primevue/rating';
import RadioButton from 'primevue/radiobutton';
import Ripple from 'primevue/ripple';
import SelectButton from 'primevue/selectbutton';
import ScrollPanel from 'primevue/scrollpanel';
import ScrollTop from 'primevue/scrolltop';
import Skeleton from 'primevue/skeleton';
import Slider from 'primevue/slider';
import Sidebar from 'primevue/sidebar';
import SplitButton from 'primevue/splitbutton';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import StyleClass from 'primevue/styleclass';
import Steps from 'primevue/steps';
import TabMenu from 'primevue/tabmenu';
import TieredMenu from 'primevue/tieredmenu';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Tag from 'primevue/tag';
import Timeline from 'primevue/timeline';
import ToggleButton from 'primevue/togglebutton';
import Tooltip from 'primevue/tooltip';
import Tree from 'primevue/tree';
import TreeSelect from 'primevue/treeselect';
import TreeTable from 'primevue/treetable';
import TriStateCheckbox from 'primevue/tristatecheckbox';

import CodeHighlight from './AppCodeHighlight';
import BlockViewer from './BlockViewer';

import VueExcelEditor from 'vue3-excel-editor';

// Temas do Prime
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
import './assets/demo/flags/flags.css';

//createApp(App).use(router).mount('#app')

import axios from 'axios';
import VueAxios from 'vue-axios';

axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;

const LOGIN_REDIRECT_STORAGE_KEY = 'login-redirect-path';

function saveLoginRedirectPath(path) {
    if (typeof path === 'string' && path.length > 0 && path !== '/login') {
        localStorage.setItem(LOGIN_REDIRECT_STORAGE_KEY, path);
    }
}

router.beforeEach((to, from, next) => {
    const isAuthenticated = !!localStorage.getItem('jwt');

    app.config.globalProperties.$isAuthenticated = isAuthenticated;

    if (!isAuthenticated && to.name !== 'login') {
        saveLoginRedirectPath(to.fullPath);
        next({ name: 'login' });
        return;
    }

    window.scrollTo(0, 0);
    next();
});

// Header do Token
axios.interceptors.request.use(
    config => {
        let accessToken = localStorage.getItem('jwt');

        if (accessToken) {
            config.headers["Authorization"] = `Bearer ${accessToken}`;
            /*
            config.headers.common = Object.assign({
                Authorization: `Bearer ${accessToken}`
            }, config.headers);
            */
        }

        /*
        if (AppConfigDefs.cliente) {
            config.headers["cliente"] = AppConfigDefs.cliente;
        }
        */

        let empresaSelecionada = localStorage.getItem('empresaSelecionada');
        if (empresaSelecionada) {
            config.headers["cliente"] = empresaSelecionada;
        }

        return config;
    },    
    error => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    response => {
        return response;
    }, 
    error => {
        // console.log('axios.interceptors.error',error);
        if (error.response.status === 401) {
            localStorage.removeItem('jwt');
            app.config.globalProperties.$isAuthenticated = false;
            saveLoginRedirectPath(router.currentRoute.value.fullPath);
            router.push({ name: 'login' })
        }

        return Promise.reject(error);
    }
);

/*
// Carrega as configurações conforme o domínio utilizado
var count = (window.location.origin.match(/\./g) || []).length;
var aux = window.location.origin.split('.')[count-2];
const AppConfigDefs = require('@/domains/' + (count > 1 ? aux : 'vorticebi') + '/AppConfigDefs.js').default;
*/

//const AppConfigDefs = require('@/domains/misp/AppConfigDefs.js').default;
//const AppConfigDefs = require('@/domains/vorticebi/AppConfigDefs.js').default;
const AppConfigDefs = require('@/domains/efficax/AppConfigDefs.js').default;
//const AppConfigDefs = require('@/domains/fagron/AppConfigDefs.js').default;
//const AppConfigDefs = require('@/domains/dhoffmann/AppConfigDefs.js').default;
//const AppConfigDefs = require('@/domains/msi/AppConfigDefs.js').default;
//const AppConfigDefs = require('@/domains/farmaplus/AppConfigDefs.js').default;
//const AppConfigDefs = require('@/domains/snap/AppConfigDefs.js').default;
//const AppConfigDefs = require('@/domains/collabe/AppConfigDefs.js').default;

document.title = AppConfigDefs.app.nome + " - " + AppConfigDefs.app.empresa;

import AppWrapper from './AppWrapper.vue';

const app = createApp({
    mounted: function() {
        if (AppConfigDefs.sifm) {
            this.axios
                .get('/pharma/bi/clientes')
                .then((response) => {
                    this.appConfigDefs.clientes = response.data.registros;

                    /*
                    -- Resolvido direto no request do Axios
                    let empresaSelecionada = localStorage.getItem('empresaSelecionada');
                    if (empresaSelecionada) {
                        this.appConfigDefs.cliente = empresaSelecionada;
                    }
                    */
                })
                .catch((error) => {
                    console.log('Erro ao consultar empresas designadas', error);
                });
        }
    },

    render () { 
        return h(AppWrapper); 
    }
});

app.config.globalProperties.$isAuthenticated = !!localStorage.getItem('jwt');
app.config.globalProperties.appConfigDefs = AppConfigDefs;

app.use(PrimeVue, { 
    ripple: true,
    locale: {
        startsWith: 'Iniciado com',
        contains: 'Contém',
        notContains: 'Não contém',
        endsWith: 'Termina com',
        equals: 'Igual',
        notEquals: 'Diferente',
        noFilter: 'Sem filtro',
        lt: 'Menor que',
        lte: 'Menor ou igual a',
        gt: 'Maior que',
        gte: 'Maior ou igual a',
        dateIs: 'Data é',
        dateIsNot: 'Data não é',
        dateBefore: 'Data vem antes',
        dateAfter: 'Data vem depois',
        clear: 'Limpar',
        apply: 'Aplicar',
        matchAll: 'Todas as condições',
        matchAny: 'Qualquer condição',
        addRule: 'Criar regra',
        removeRule: 'Deletar regra',
        accept: 'Sim',
        reject: 'Não',
        choose: 'Escolher',
        upload: 'Enviar',
        cancel: 'Cancelar',
        completed: 'Completo',
        pending: 'Pendente',
        dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        dayNamesMin: ['Do', 'Se', 'Te', 'Qa', 'Qi', 'Se', 'Sa'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        chooseYear: 'Selecionar ano',
        chooseMonth: 'Selecionar mês',
        chooseDate: 'Selecionar data',
        prevDecade: 'Década passada',
        nextDecade: 'Próxima Década',
        prevYear: 'Ano anterior',
        nextYear: 'Próximo ano',
        prevMonth: 'Mês anterior',
        nextMonth: 'Próximo mês',
        prevHour: 'Hora anterior',
        nextHour: 'Próxima hora',
        prevMinute: 'Minuto anteiror',
        nextMinute: 'Próximo minuto',
        prevSecond: 'Segundo anterior',
        nextSecond: 'Próximo segundo',
        am: 'am',
        pm: 'pm',
        today: 'Hoje',
        weekHeader: 'Sem',
        firstDayOfWeek: 0,
        dateFormat: 'mm/dd/yy',
        weak: 'Semana',
        medium: 'Médigo',
        strong: 'Forte',
        passwordPrompt: 'Entre com uma senha',
        emptyFilterMessage: 'Nenhum resultado encontrado', // @deprecated Use 'emptySearchMessage' option instead.
        searchMessage: '{0} registros disponíveis',
        selectionMessage: '{0} itens selecionados',
        emptySelectionMessage: 'Nenhum item selecionado',
        emptySearchMessage: 'Nenhum resultado encontrado',
        emptyMessage: 'Nenhuma opção disponível',
        aria: {
            trueLabel: 'Verdadeiro',
            falseLabel: 'Falso',
            nullLabel: 'Não selecionado',
            star: '1 estrela',
            stars: '{star} estrelas',
            selectAll: 'Todos itens selecionados',
            unselectAll: 'Todos itens não selecionados',
            close: 'Fechar',
            previous: 'Anterior',
            next: 'Próximo',
            navigation: 'Navegação',
            scrollTop: 'Rolar para',
            pageLabel: 'Página'
        }
    }
});

app.use(ConfirmationService);
app.use(ToastService);
app.use(router);
app.use(VueAxios, axios);

app.use(VueExcelEditor);

app.config.globalProperties.$appState = reactive({ colorScheme: 'dark' });

app.directive('tooltip', Tooltip);
app.directive('badge', BadgeDirective);
app.directive('ripple', Ripple);
app.directive('code', CodeHighlight);
app.directive('styleclass', StyleClass);

app.component('Accordion', Accordion);
app.component('AccordionTab', AccordionTab);
app.component('AutoComplete', AutoComplete);
app.component('Avatar', Avatar);
app.component('AvatarGroup', AvatarGroup);
app.component('Badge', Badge);
app.component('Breadcrumb', Breadcrumb);
app.component('Button', Button);
app.component('Calendar', Calendar);
app.component('Card', Card);
app.component('Carousel', Carousel);
app.component('CascadeSelect', CascadeSelect);
app.component('Chart', Chart);
app.component('Checkbox', Checkbox);
app.component('Chip', Chip);
app.component('Chips', Chips);
app.component('ColorPicker', ColorPicker);
app.component('Column', Column);
app.component('ConfirmDialog', ConfirmDialog);
app.component('ConfirmPopup', ConfirmPopup);
app.component('ContextMenu', ContextMenu);
app.component('DataTable', DataTable);
app.component('DataView', DataView);
app.component('DataViewLayoutOptions', DataViewLayoutOptions);
app.component('Dialog', Dialog);
app.component('Divider', Divider);
app.component('Dropdown', Dropdown);
app.component('Fieldset', Fieldset);
app.component('FileUpload', FileUpload);
app.component('FullCalendar', FullCalendar);
app.component('Galleria', Galleria);
app.component('Image', Image);
app.component('InlineMessage', InlineMessage);
app.component('Inplace', Inplace);
app.component('InputMask', InputMask);
app.component('InputNumber', InputNumber);
app.component('InputSwitch', InputSwitch);
app.component('InputText', InputText);
app.component('Knob', Knob);
app.component('Listbox', Listbox);
app.component('MegaMenu', MegaMenu);
app.component('Menu', Menu);
app.component('Menubar', Menubar);
app.component('Message', Message);
app.component('MultiSelect', MultiSelect);
app.component('OrderList', OrderList);
app.component('OrganizationChart', OrganizationChart);
app.component('OverlayPanel', OverlayPanel);
app.component('Paginator', Paginator);
app.component('Panel', Panel);
app.component('PanelMenu', PanelMenu);
app.component('Password', Password);
app.component('PickList', PickList);
app.component('ProgressBar', ProgressBar);
app.component('RadioButton', RadioButton);
app.component('Rating', Rating);
app.component('SelectButton', SelectButton);
app.component('ScrollPanel', ScrollPanel);
app.component('ScrollTop', ScrollTop);
app.component('Slider', Slider);
app.component('Sidebar', Sidebar);
app.component('Skeleton', Skeleton);
app.component('SplitButton', SplitButton);
app.component('Splitter', Splitter);
app.component('SplitterPanel', SplitterPanel);
app.component('Steps', Steps);
app.component('TabMenu', TabMenu);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Tag', Tag);
app.component('Textarea', Textarea);
app.component('TieredMenu', TieredMenu);
app.component('Timeline', Timeline);
app.component('Toast', Toast);
app.component('Toolbar', Toolbar);
app.component('ToggleButton', ToggleButton);
app.component('Tree', Tree);
app.component('TreeSelect', TreeSelect);
app.component('TreeTable', TreeTable);
app.component('TriStateCheckbox', TriStateCheckbox);
app.component('BlockViewer', BlockViewer);

app.mount('#app');
